'use client';

/** @type {import("@mui/material").SxProps<typeof import('@mui/material/styles').Theme>} */
export const useStyles = theme => ({
  divider: {
    mb: '2.5rem',
  },
  fields: {
    [theme.breakpoints.down('sm')]: {
      p: 0,
    },
    [theme.breakpoints.between('sm', 'md')]: {
      p: '0 5rem',
    },
    [theme.breakpoints.between('md', 'lg')]: {
      p: '0 6rem',
    },
  },
  link: {
    textDecoration: 'underline',
    cursor: 'pointer',
    textAlign: 'left',
    color: theme?.palette?.default?.linkColor,
  },
  forgotLink: {
    textAlign: 'left',
  },
  alert: {
    width: 'fit-content',
    m: '1.5rem auto 0 auto',
    color: theme?.palette?.default?.textColor3,
    background: `linear-gradient(0deg, ${theme?.palette?.default?.boxShadow1},  ${theme?.palette?.default?.boxShadow1}), ${theme?.palette?.default?.alert}`,
    '& .MuiAlert-icon': {
      color: theme?.palette?.default?.alert,
    },
  },
  inputTextbox: {
    width: '100%',
    '& .MuiSvgIcon-root': {
      color: theme?.palette?.default?.textColor3,
    },
    '& .MuiInputLabel-root': { color: theme?.palette?.default?.textColor3 },
    '& label.Mui-focused': {
      color: theme?.palette?.default?.buttonColor,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: theme?.palette?.default?.buttonColor,
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: theme?.palette?.default?.buttonColor,
      },
    },
    '& .MuiFormHelperText-root': {
      color: theme?.palette?.default?.error,
      ml: 0,
    },
  },
});
